// extracted by mini-css-extract-plugin
module.exports = {"layout":"SubscribeLayout_layout__k6ph_"};